import { redirectToHomeIfMcpAccessDisabled } from '@/mcp/router/guards';

const McpAuthorizePage = () => import('@/mcp/pages/mcp-authorize.vue');

export const mcpRoutes = [
  {
    path: '/mcp/authorize/:requestId',
    name: 'mcp-authorize',
    component: McpAuthorizePage,
    beforeEnter: redirectToHomeIfMcpAccessDisabled,
    meta: {
      layout: 'layout-empty',
    },
  },
];
